<template>
    <HomeSectionContainer :title="t('userPreferences.interfaceLanguage.title')">
        <template #subtitle>
            <p class="body-small text-ink-muted">
                {{ t("userPreferences.interfaceLanguage.subtitle") }}
            </p>
        </template>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 items-stretch">
            <AccountSetting :error="error">
                <template #label>{{ t("userPreferences.interfaceLanguage.label") }}</template>
                <template #content>
                    <AccountSettingSelect
                        id="s_ui_language"
                        :aria-label="t('userPreferences.interfaceLanguage.selectA11yLabel')"
                        :choices="uiLanguageChoices"
                        :model-value="uiLanguage ?? ''"
                        @update:model-value="onChange" />
                </template>
            </AccountSetting>
        </div>
    </HomeSectionContainer>
</template>

<script setup lang="ts">
import { router } from "@inertiajs/vue3";
import HomeSectionContainer from "~vue/ChatHome/HomeSectionContainer.vue";
import AccountSetting from "~vue/UserProfile/AccountSetting.vue";
import AccountSettingSelect from "~vue/UserProfile/AccountSettingSelect.vue";
import { useI18n } from "vue-i18n";

import { getCookie } from "../../utils";

const { t } = useI18n();

const props = defineProps<{
    uiLanguage: string | null;
    uiLanguageChoices: [string, string, string][];
    error?: string;
    profileEndpoint: string;
    currentPageEndpoint: string;
}>();

function onChange(value: string) {
    router.post(
        props.profileEndpoint,
        { ui_language: value, detail: "ui_language" },
        {
            errorBag: "account_settings",
            headers: {
                "X-CSRFToken": getCookie("csrftoken") ?? "",
                "X-Inertia-Next": props.currentPageEndpoint,
            },
            preserveScroll: true,
            // "locale" refreshes the shared prop app.js watches to update <html lang> immediately
            // after this save, without a reload (BRA-1045 AC18).
            only: ["user_profile", "errors", "user_details", "locale"],
        },
    );
}
</script>
